import { RemoteContractors } from '../../../data/usecases/contractors/remote-contractors'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeContractors = () => new RemoteContractors('/users/me/contractor', makeAxiosHttpClient())
